
import * as React from "react"

const MOBILE_BREAKPOINT = 768

export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState<boolean | undefined>(undefined)

  React.useEffect(() => {
    // Função para verificar se é dispositivo móvel com melhorias
    const checkIsMobile = () => {
      // Verificar por toque (dispositivos móveis têm tela sensível ao toque)
      const hasTouchScreen = 'ontouchstart' in window || 
        navigator.maxTouchPoints > 0 || 
        (window.matchMedia && window.matchMedia('(pointer: coarse)').matches);
      
      // Verificar tamanho da tela (approach tradicional)
      const isMobileByWidth = window.innerWidth < MOBILE_BREAKPOINT;
      
      // Verificar user agent para identificar navegadores móveis - incluindo mais padrões
      const mobileUAPattern = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS|Tablet/i;
      const isMobileByUA = mobileUAPattern.test(navigator.userAgent);
      
      // Verificar específicamente para iOS
      const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
      
      // Verificar orientação (se disponível)
      const isPortrait = window.innerHeight > window.innerWidth;
      
      // Combinar com mais peso para tamanho da tela em marketing de conversão
      const indicators = [
        { value: hasTouchScreen, weight: 1 },
        { value: isMobileByWidth, weight: 3 }, // Damos mais peso para largura da tela
        { value: isMobileByUA, weight: 2 },
        { value: isIOS, weight: 1 },
        { value: isPortrait, weight: 1 }
      ];
      
      // Calcular pontuação ponderada
      const totalWeight = indicators.reduce((sum, ind) => sum + ind.weight, 0);
      const weightedScore = indicators.reduce((score, ind) => score + (ind.value ? ind.weight : 0), 0) / totalWeight;
      
      // Console para debug
      console.log('Mobile detection:', { 
        hasTouchScreen, 
        isMobileByWidth, 
        isMobileByUA, 
        isIOS, 
        isPortrait, 
        weightedScore, 
        width: window.innerWidth,
        isMobile: weightedScore > 0.5 || isMobileByWidth
      });
      
      // Retorna true se a pontuação ponderada for maior que 0.5 ou se o critério de largura for atendido
      return weightedScore > 0.5 || isMobileByWidth;
    };

    // Usar media query list e eventos para detectar mudanças
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`)
    
    const onChange = () => {
      setIsMobile(checkIsMobile());
    }
    
    // Adicionar listener para mudança de tamanho de tela
    mql.addEventListener("change", onChange)
    
    // Verificar na primeira execução
    setIsMobile(checkIsMobile());
    
    // Verificar também ao mudar orientação do dispositivo
    window.addEventListener('orientationchange', onChange);
    
    // Limpar listeners
    return () => {
      mql.removeEventListener("change", onChange);
      window.removeEventListener('orientationchange', onChange);
    }
  }, [])

  return !!isMobile;
}
